export default __webpack_public_path__ + "static/fundo-produtos-a941e0ff743e3a1abf6b5433d335ef10.jpg";